module.exports = __webpack_public_path__ + "media/images/icons/profile-713dd5e5c9675c553aabe755126ecc02.svg";